/*
// mobile footer accordions
$(document).ready(function(){
  if (window.innerWidth < 768) {
    $('.site-footer .flex__item:not(.last) .site-footer__section-title').css('cursor','pointer');
    $('.site-footer .flex__item:not(.last) .site-footer__section-title').parents(".flex__item").siblings(".flex__item").find(".site-footer__section-title").nextUntil("h4").slideToggle(0);

    $('.site-footer .flex__item:not(.last) .site-footer__section-title').click(function() {
      $(this).parents(".flex__item").siblings(".flex__item").find(".site-footer__section-title").nextUntil("h4").slideUp();
      $(this).nextUntil("h4").slideToggle();
    });
  }

  $( window ).resize(function() {
    if (window.innerWidth < 768) {
      $('.site-footer .flex__item:not(.last) .site-footer__section-title').css('cursor','pointer');
      $('.site-footer .flex__item:not(.last) .site-footer__section-title').parents(".flex__item").siblings(".flex__item").find(".site-footer__section-title").nextUntil("h4").slideToggle(0);

      $('.site-footer .flex__item:not(.last) .site-footer__section-title').click(function() {
        $(this).parents(".flex__item").siblings(".flex__item").find(".site-footer__section-title").nextUntil("h4").slideUp();
        $(this).nextUntil("h4").slideToggle();
      });
    }
  });
});
*/

// instafeed volume workaround
document.addEventListener("DOMContentLoaded", () => {
  setTimeout(function() {
    let boxes = [...document.getElementsByClassName("instafeed-lightbox")];
  	let videos = [...document.getElementsByTagName("video")];
    boxes.map(box => {
      box.addEventListener("click", () => {
        videos.map(video => {
          video.pause();
        });
      });
    });
  }, 3000);

  $('[js-search="reset"]').on('click', function() {
    $('[js-search="input"]').val('');
  })

  $('[js-search="item"]').on('click', function() {
    const isProductTab = $(this).data('item') === 'product';

    if (isProductTab) {
      $('[js-search="product-content"]').addClass('is-active');
      $('[js-search="item"][data-item="product"]').addClass("is-active");
      $('[js-search="page-content"]').removeClass("is-active");
      $('[js-search="item"][data-item="page"]').removeClass("is-active");
    } else {
      $('[js-search="page-content"]').addClass("is-active");
      $('[js-search="item"][data-item="page"]').addClass("is-active");
      $('[js-search="product-content"]').removeClass("is-active");
      $('[js-search="item"][data-item="product"]').removeClass("is-active");
    }
  });

  const searchUrl = new URL(window.location.href);
  const searchQuery = searchUrl.searchParams.get("q");
  const url = `https://dryrobe.myshopify.com/api/2023-07/graphql.json`;
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": "35b60e90ccabebed06ef6b07970e5249",
    },
  };

  async function handleProducts(query, after) {
    if (!query) {
      return
    }

    const res = await fetch(url, {
      ...options,
      body: JSON.stringify({
        query: `
          query searchProducts(
            $first: Int!,
            $query: String!,
            $after: String,
            $country: CountryCode!
            )
            @inContext(country: $country) {
            search(first: $first, query: $query, after: $after, types: PRODUCT) {
              pageInfo {
                endCursor
                hasNextPage
              }
              edges {
                node {
                  ... on Product {
                    id
                    title
                    handle
                    productType
                    metafields(
                      identifiers: { namespace: "product_fields", key: "featured_image" }
                    ) {
                      key
                      reference {
                        ... on MediaImage {
                          image {
                            url
                            altText
                          }
                        }
                      }
                    }
                    options {
                      name
                      values
                    }
                    featuredImage {
                      url
                      altText
                    }
                    priceRange {
                      minVariantPrice {
                        amount
                        currencyCode
                      }
                    }
                    compareAtPriceRange {
                      minVariantPrice {
                        amount
                        currencyCode
                      }
                    }
                  }
                }
              }
            }
          }
        `,
        variables: {
          country: window.Shopify.country || 'GB',
          first: 20,
          query,
          after,
        },
      }),
    });

    const { data } = await res.json()
    const productResults = data.search
    const products = productResults.edges.map(edge => edge.node)
    const productContainer = document.querySelector(
      '[js-search="product-data"]'
    );

    if (!products.length) {
      $('[js-search="page-content"]').addClass("is-active");
      $('[js-search="item"][data-item="page"]').addClass("is-active");
      $('[js-search="product-content"]').removeClass("is-active");
      $('[js-search="item"][data-item="product"]').removeClass("is-active");
      $('[js-search="item"][data-item="product"]').hide();
    }

    if (!data || !productContainer) {
      return;
    }

    if (!after) {
      productContainer.innerHTML = "";
    }

    if (!productResults.pageInfo.hasNextPage) {
      $('[js-search="product-load-more"]').hide();
    } else {
      $('[js-search="product-load-more"]').attr(
        "data-after",
        productResults.pageInfo.endCursor
      );
    }

    products.forEach((product) => {
      let image = product.featuredImage.url
        .replace(".jpg", "_x480.jpg")
        .replace(".png", "_x480.png")

      const colorOptions = product.options
        .find(opt => opt.name === 'Color' || opt.name === 'Colour')?.values

      const hasMetafieldImage = product.metafields
        .find(metafield => metafield?.key === 'featured_image')?.reference?.image

      if (hasMetafieldImage) {
        image = hasMetafieldImage.url
          .replace(".jpg", "_x480.jpg")
          .replace(".png", "_x480.png")
      }

      productContainer.innerHTML += `
        <div class="grid__item small--one-half medium-up--one-quarter">
          <div class="product-card-grid">
            <a class="product-card" href="/products/${product.handle}">
              <div class="product-card__image-wrapper">
                <img
                  class="product-card__image lazyload"
                  alt="${product.featuredImage.altText}"
                  src="${image}"
                  data-src="${image}"
                  height="300"
                />
              </div>

              <div class="product-card__info">
                <div class="product-card__price">
                  <span class="money">
                    ${theme.strings.currencySymbol}
                    ${Number(product.priceRange.minVariantPrice.amount).toFixed()}
                  </span>
                </div>

                <div class="product-card__name">
                  ${product.title}
                </div>

                <div class="product-card__type">
                  ${product.productType}
                </div>

                <div
                  class="product-card__options"
                  style="font-size: 12px; color: #000; letter-spacing: 1px;"
                >
                  ${colorOptions || ""}
                </div>

                <div style="text-align:left;margin-left:-2px;">
                  <div
                    class="yotpo bottomLine"
                    data-product-id="${product.id.split("/").at(-1)}"
                    style="min-height:18px"
                  ></div>
                </div>
              </div>
            </a>
          </div>
        </div>
      `;
    })

    window.yotpo?.initWidgets()
  }

  async function handlePages(query, after) {
    if (!query) {
      return
    }

    const res = await fetch(url, {
      ...options,
      body: JSON.stringify({
        query: `
          query searchPagesAndArticles($first: Int!, $query: String!, $after: String) {
            search(first: $first, query: $query, after: $after, types: [PAGE, ARTICLE]) {
              pageInfo {
                endCursor
                hasNextPage
              }
              edges {
                node {
                  ... on Page {
                    id
                    title
                    handle
                    bodySummary
                  }
                  ... on Article {
                    id
                    title
                    handle
                    excerpt
                    blog {
                      handle
                    }
                  }
                }
              }
            }
          }
        `,
        variables: {
          first: 20,
          query,
          after,
        },
      }),
    });

    const { data } = await res.json()
    const pageResults = data.search
    const pageContainer = document.querySelector('[js-search="page-data"]');
    const pages = pageResults.edges.map(edge => edge.node)

    if (!pages.length) {
      $('[js-search="product-content"]').addClass('is-active');
      $('[js-search="item"][data-item="product"]').addClass("is-active");
      $('[js-search="page-content"]').removeClass("is-active");
      $('[js-search="item"][data-item="page"]').removeClass("is-active");
      $('[js-search="item"][data-item="page"]').hide();
    }

    if (!data || !pageContainer) {
      return;
    }

    if (!after) {
      pageContainer.innerHTML = "";
    }

    pages.forEach((page) => {
      const link = page.id.includes("Article")
        ? `/blogs/${page.blog.handle}/${page.handle}`
        : `/pages/${page.handle}`;

      pageContainer.innerHTML += `
        <div
          class="
            search__result-item
            search__result-item--page
          "
        >
          <a href="${link}">
            <h5 class="search__result-item-title">
              ${page.title}
            </h5>

            <div class="search__result-item-body rte">
              ${page.bodySummary || page.excerpt}
            </div>

            <p class="class="search__result-item-link">
              <strong>${theme.strings.readMore}</strong>
            </p>
          </a>
        </div>
      `;
    });

    if (!pageResults.pageInfo.hasNextPage) {
      $('[js-search="page-load-more"]').hide();
    } else {
      $('[js-search="page-load-more"]').attr(
        "data-after",
        pageResults.pageInfo.endCursor
      );
    }
  }

  handleProducts(searchQuery)
  handlePages(searchQuery)

  $('[js-search="product-load-more"]').on('click', function() {
    const after = $(this).attr('data-after')

    handleProducts(searchQuery, after)
  })

  $('[js-search="page-load-more"]').on("click", function () {
    const after = $(this).attr("data-after")

    handlePages(searchQuery, after)
  })
})
